import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(879);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 879);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-[#f5a623] text-[#0a0a0a] py-2.5 px-5 text-center font-['Barlow_Condensed'] font-extrabold text-[14px] uppercase tracking-[0.05em] shadow-md" data-id="element-3">
      🔒 PRECIO DE LANZAMIENTO — ACCESO INMEDIATO EN MENOS DE 2 MINUTOS
    </div>;
}